export enum Permission {
  HOME = 'menu.home',
  PERSONAL = 'menu.personal',
  ASSIGNER = 'menu.assigner',
  SERVICE_MANAGER = 'menu.service_manager',
  PROVIDERS = 'menu.providers',
  CLIENTS = 'menu.clients',
  COMMERCIAL = 'menu.commercial',
  SWEEPERCAR = 'menu.sweeper_car',
  POOL_MANAGER = 'menu.pool_manager',
  EXPENSES = 'menu.expenses',
}
